// User type constants based on backend enum
export const USER_TYPES = {
  SUPER_ADMIN: "superAdmin",
  ADMIN: "admin",
  REGULAR: "regular",
  CHATBOT: "chatbot",
  RENTAL: "rental",
  INSPECTION: "inspection",
  OPERATE: "operate",
  FREESBE: "freesbe",
} as const;

// Type for individual user type values
export type UserTypeValue = typeof USER_TYPES[keyof typeof USER_TYPES];

// Complete User interface matching the backend User model
export interface User {
  _id?: string;
  username: string;
  name: string;
  email: string;
  password: string;
  phone?: string;
  userType: UserTypeValue[];
  sendNewChatEmail?: boolean;
  sendFuelCodeStatusEmail?: boolean;
  // tracking conversation flow
  conversationState?: string;
  // Stores answers collected during the flow
  conversationData?: Record<string, any>;
  // Stores the last response sent to the user
  lastResponseSent?: string;
  lastResponseReceived?: string;
  // date of last message received
  lastMessageReceivedDate?: Date;
  lastFuelCodeSentAt?: Date;
  userWatingForFirstHumanResponse?: boolean;
  closedChatAt?: Date;
  representativeChatType?: "attached_general" | "pool_rental";
}

// Export for backward compatibility
export default User;

